module.exports = __webpack_public_path__ + "static/paga-5182cb3d0bf8a68fe326acc5b355d4c7.svg";